import { useAppSelector } from '../../core/store';
import UserTypeOrganization from '../../core/types/Enums/UserTypeOrganization';

const useUser = () => {
    const { data: user, dataLoading: isUserLoading, dataError: loadingError } = useAppSelector((state) => state.user);

    const isLantis = user.userTypeOrganizationId === UserTypeOrganization.Lantis;
    const isContractor = user.userTypeOrganizationId === UserTypeOrganization.Contractor;
    const isStakeholder = user.userTypeOrganizationId === UserTypeOrganization.Stakeholder;

    return { user, isUserLoading, loadingError, isLantis, isContractor, isStakeholder };
};

export default useUser;
